import React, { ComponentType, Fragment, useLayoutEffect } from 'react'

export type BodyClassUpdaterCompProps = {
	isMobile: string
	withRuntimeMesh: boolean
	disableSiteOverflow: boolean
}

export const BodyClassUpdater: ComponentType<BodyClassUpdaterCompProps> = ({
	isMobile = false,
	withRuntimeMesh = false,
	disableSiteOverflow = false,
}) => {
	// use the useLayoutEffect hook to update the body class on the right time (between the render and the browser layout)
	useLayoutEffect(() => {
		const bodyClass = window.document.body.classList
		const mobileOptimizedClass = 'device-mobile-optimized'
		const withRuntimeMeshClass = 'with-runtime-mesh'
		const disableSiteOverflowClass = 'disable-site-overflow'
		isMobile ? bodyClass.add(mobileOptimizedClass) : bodyClass.remove(mobileOptimizedClass)
		withRuntimeMesh ? bodyClass.add(withRuntimeMeshClass) : bodyClass.remove(withRuntimeMeshClass)
		disableSiteOverflow ? bodyClass.add(disableSiteOverflowClass) : bodyClass.remove(disableSiteOverflowClass)
	}, [isMobile, withRuntimeMesh, disableSiteOverflow])

	return <Fragment />
}
